<template>
  <bar :chartdata="chartdata" :options="options"/>
</template>

<script>
import Bar from '@/components/charts/bar'

export default {
  name: 'ToolsOutdatedVersion',
  components: {
    Bar
  },
  props: {
    toolsOutdated: {
      type: Object,
      default: () => {}
    },
    accounts: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return `${tooltipItem.yLabel} accounts`
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Accounts'
            },
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      }
    }
  },
  methods: {
    fillchartdata: function () {
      const dataset = []
      const labels = []
      for (const tool in this.toolsOutdated) {
        dataset.push(this.toolsOutdated[tool].length)
        labels.push(tool)
      }

      this.chartdata = {
        labels: labels,
        datasets: [{
          data: dataset,
          backgroundColor: '#118ab2'
        }]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ToolsOutdatedVersion.vue